import { useCapAutomatorInfo } from '@/domain/cap-automator/useCapAutomatorInfo'
import { CheckedAddress } from '@/domain/types/CheckedAddress'
import { useChainId } from 'wagmi'
import { QUERY_REFETCH_INTERVAL } from '@/config/consts'
import { getAddressBySymbol, TokenSymbolEnum } from '@/utils/tokens'
import { makeMarketOverview } from '@/features/market-details/logic/makeMarketOverview'
import { useMarketInfo } from '@/domain/market-info/useMarketInfo'
import { HistoricInterestRatePanel } from './HistoricInterestRatePanel'
import { links } from '@/ui/constants/links'

export function HistoricalInterest() {
  const chainId = useChainId()

  const { marketInfo } = useMarketInfo({ chainId, refetchInterval: QUERY_REFETCH_INTERVAL })
  const reserve = marketInfo.findReserveByUnderlyingAsset(CheckedAddress(getAddressBySymbol(TokenSymbolEnum.USDXL)))!

  const { capAutomatorInfo } = useCapAutomatorInfo({
    chainId,
    token: reserve.token,
    // token: isDaiOverview ? marketInfo.sDAI : reserve.token,
  })

  const marketOverview = makeMarketOverview({
    reserve,
    marketInfo,
    capAutomatorInfo,
    facilitator: marketInfo.facilitator,
  })

  return (
    <HistoricInterestRatePanel
      borrowStatus={marketOverview.borrow.status}
      supplyStatus={'no'}
      chainId={chainId}
      tokenAddress={CheckedAddress(getAddressBySymbol(TokenSymbolEnum.USDXL))}
      description="Borrow APR increases when USDXL price is below .995 and decreases when it is above."
      docsLink={links.docs.usdxl}
    />
  )
}
